import { OrderEventsOverview } from 'projects/access-gui/views/orderevents'

module.exports = [
  {
    path: '/events',
    exact: true,
    component: OrderEventsOverview
  }
]



// WEBPACK FOOTER //
// ./src/projects/access-gui/routes/orderevents.js